import { makeStyles, withStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const {
	PURPLE,
	LIGHT_GREY,
	LIGHT_GRAY_SHADE,
	GREY,
	FONT_COLOR,
	TOGGLE_ACTIVE,
	WHITE,
	HOVER_GRAY_SHADE
} = colors;
import { InputBase, AccordionDetails } from '@material-ui/core';
import { Bogle_Medium, Bogle_Regular } from 'constants/constant';

const previewElementStyle = makeStyles((theme) => ({
	root: {
		display: 'flex'
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1
	},
	drawer: {
		width: '360px',
		flexShrink: 0
	},
	drawerContainer: {
		width: '360px',
		height: '100vh',
		overflowY: 'auto',
		marginTop: '64px'
	},
	relative: {
		position: 'relative'
	},
	titleFont: {
		fontSize: '20px',
		fontFamily: Bogle_Regular,
		fontWeight: 300,
		height: '50px',
		display: 'flex',
		alignItems: 'center',
		marginLeft: '16px !important',
		'& img': {
			paddingRight: '10px'
		}
	},
	subHeader: {
		paddingLeft: '16px',
		background: LIGHT_GRAY_SHADE,
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		height: '32px'
	},
	subHeaderText: {
		fontSize: '14px',
		fontFamily: `${Bogle_Medium} !important`
	},
	subHeaderCount: {
		paddingRight: '16px',
		color: GREY,
		fontFamily: Bogle_Medium,
		fontSize: '12px'
	},
	attrTypeText: {
		fontSize: '12px',
		color: GREY,
		marginLeft: '26px',
		display: 'flex',
		alignItems: 'center'
	},
	listContainer: {
		padding: 0,
		top: 0
	},
	lists: {
		maxHeight: '348px',
		overflowY: 'auto'
	},
	listItemText: {
		fontSize: '14px',
		fontFamily: Bogle_Regular,
		display: 'flex',
		alignItems: 'center'
	},
	listItemRow: {
		height: '16px',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center'
	},
	titleContainer: {
		// position: 'fixed',
		minWidth: 360
	},
	searchBox: {
		position: 'relative',
		marginLeft: theme.spacing(1),
		width: 'auto',
		display: 'flex',
		justifyContent: 'space-between'
	},
	searchBoxIcon: {
		padding: '0px 8px',
		height: '100%',
		color: GREY,
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	crossIcon: {
		color: GREY,
		display: 'flex',
		alignItems: 'center',
		marginRight: '24px',
		'& .MuiSvgIcon-root': {
			width: '18px'
		}
	},
	closeIcon: {
		color: PURPLE,
		fontFamily: Bogle_Regular,
		fontSize: '16px',
		cursor: 'pointer',
		'&:hover': {
			size: 40,
			backgroundColor: 'rgba(51, 51, 51, 0.10)'
		}
	},
	floatRight: {
		position: 'absolute',
		right: '0px',
		padding: '8px'
	},
	proTipText: {
		fontFamily: Bogle_Regular,
		fontSize: '12px'
	},
	footerText: {
		color: '#B2B0B9',
		fontFamily: Bogle_Regular,
		fontSize: '12px',
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		paddingRight: 16
		// height: '100%'
	},
	proTipContainer: {
		height: '48px',
		backgroundColor: '#F1F1F2',
		border: '1px solid #E3E4E5',
		borderRight: 0,
		borderLeft: 0
	},
	footer: {
		borderTop: `1px solid ${LIGHT_GREY}`,
		position: 'fixed',
		bottom: 0,
		zIndex: 999,
		minWidth: '336px',
		background: WHITE
	},
	defaultFooterHeight: {
		height: '32px'
	},
	proTipFooterHeight: {
		height: '80px'
	},
	footerIcon: {
		border: `1px solid`,
		borderRadius: '50%',
		height: '16px',
		width: '16px',
		'&:hover': {
			backgroundColor: 'unset'
		}
	},
	checkboxIcon: {
		color: FONT_COLOR,
		'&:hover': {
			backgroundColor: 'unset'
		}
	},
	listIcon: {
		display: 'inline-flex',
		alignItems: 'center',
		marginRight: '8px',
		height: '14px'
	},
	footerCount: {
		marginRight: '8px'
	},
	button: {
		textTransform: 'unset',
		borderRadius: '20px',
		marginTop: '2px',
		backgroundColor: 'transparent',
		'&:hover': {
			background: TOGGLE_ACTIVE
		}
	},
	buttonLabel: {
		fontSize: '14px',
		fontWeight: 400,
		color: PURPLE,
		fontFamily: Bogle_Regular,
		cursor: 'pointer'
	},
	filterIcon: {
		right: '30px',
		color: WHITE,
		position: 'absolute'
	},
	showFilter: {
		color: FONT_COLOR
	},
	noMatchPanel: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '48px',
		background: HOVER_GRAY_SHADE
	},
	noMatch: {
		fontSize: '12px',
		fontFamily: `${Bogle_Medium}!important`,
		color: GREY,
		padding: '0 16px'
	},
	accordian: {
		border: `1px solid ${LIGHT_GREY}`,
		borderTop: 0,
		borderRight: 0,
		borderLeft: 0
	},
	panel: {
		// marginTop: '100px',
		position: 'fixed',
		overflowY: 'scroll',
		maxHeight: 'calc(100vh - 246px)',
		minWidth: '360px'
	},
	customDatasetPanel: {
		position: 'fixed',
		overflowY: 'scroll',
		maxHeight: 'calc(100vh - 296px)',
		minWidth: '360px'
	},
	ellipseText: {
		fontSize: '20px',
		fontFamily: Bogle_Regular,
		fontWeight: 300,
		width: '70%',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis'
	},
	pinnedIcon: {
		display: 'flex',
		padding: '4px',
		color: GREY,
		borderRadius: '50%',
		alignItems: 'center',
		position: 'relative',
		'&:hover': {
			background: '#dadada'
		}
	},
	pinnedDataHeader: {
		display: 'flex',
		fontSize: '14px',
		alignItems: 'center',
		fontFamily: Bogle_Regular
	},
	pinnedDataCount: {
		right: '4px',
		display: 'flex',
		fontSize: '14px',
		alignItems: 'center',
		position: 'absolute'
	},
	attributesCount: {
		color: GREY,
		fontSize: '14px',
		marginRight: '4px'
	},
	pinAttributeTooltip: {
		width: '212px',
		padding: '16px',
		fontSize: '12px',
		lineHeight: '20px',
		fontFamily: Bogle_Medium
	},
	pinnedFolderAccordion: {
		borderTop: `1px solid ${LIGHT_GREY}`,
		borderLeft: 0,
		borderRight: 0,
		borderBottom: 0
	},
	tooltip: {
		maxWidth: 234,
		padding: 16,
		fontFamily: Bogle_Medium,
		color: WHITE,
		fontSize: '14px'
	},
	unsaved: {
		fontSize: '20px',
		fontFamily: Bogle_Regular,
		paddingRight: 4,
		color: '#333333'
	}
}));

export const StyledInputBase = withStyles((theme) => ({
	input: {
		padding: theme.spacing(1, 1, 1, 0),
		paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
		height: '30px',
		fontFamily: Bogle_Regular,

		'&::placeholder': {
			color: '#6D6E71',
			opacity: 0.75
		}
	},
	root: {
		width: '85%'
	}
}))(InputBase);

export const StyledAccordianDetail = withStyles(() => ({
	root: {
		maxHeight: 'calc(100vh - 333px)',
		overflowY: 'auto'
	}
}))(AccordionDetails);
export default previewElementStyle;
